export const GetEnvVar = () => {
    const host = window.location.host;
    if (host === "devportal.instabrain.io") {
        return process.env["REACT_APP_BASE_URL_PRODUCTION"]
    }
    else if (host === "devportal.instabrainstage.io") {
        return process.env["REACT_APP_BASE_URL_STAGING"]
    } else if (host === "devportal.instabrainsandbox.io") {
        return process.env["REACT_APP_BASE_URL_SANDBOX"]
    }
    else if (host === "devportal.instabrain-dev.io" || host.includes("localhost")) {
        return process.env["REACT_APP_BASE_URL_DEVELOPMENT"]
    }
    else {
        return process.env["REACT_APP_BASE_URL_DEVELOPMENT"]
    }
}

export const GetAllApiBaseUrls = (): string[] =>
    [
        process.env.REACT_APP_BASE_URL_PRODUCTION,
        process.env.REACT_APP_BASE_URL_STAGING,
        process.env.REACT_APP_BASE_URL_SANDBOX,
        process.env.REACT_APP_BASE_URL_DEVELOPMENT,
        process.env.REACT_APP_BASE_URL_LOCAL,
    ].filter((url): url is string => Boolean(url));